export type SearchField = {
  fieldPath: string;
  localized: boolean;
};

export const DEFAULT_SEARCH_FIELDS: SearchField[] = [
  { fieldPath: "data.title", localized: true },
  { fieldPath: "data.description", localized: true },
];

const CVE_SEARCH_FIELDS: SearchField[] = [
  { fieldPath: "data.title", localized: true },
  { fieldPath: "data.index", localized: false },
  { fieldPath: "data.fixedVersion", localized: false },
];

export const getSearchFieldsByVariant = (variant?: string): SearchField[] => {
  switch (variant) {
    case "CVE":
      return CVE_SEARCH_FIELDS;
    default:
      return DEFAULT_SEARCH_FIELDS;
  }
};
